import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { selectAllExistingBuildingInfo } from "../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../utils/utilBuildings";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionApp } from "../../app/actionApp";
import { actionBaseInfoFinishConstruction } from "../../info/base/actionBaseInfo";
import { actionBuildingsSelectForData } from "../../player-base/buildings/actionBuildings";
export var epicTimeConstruction = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(utilTick.second$), switchMap(function () {
        var state = state$.value;
        var _a = state.playerBase.buildings, selectedBuilding = _a.building, buildingCenterCoords = _a.buildingCenterCoords;
        var actions = [];
        selectAllExistingBuildingInfo(state)
            .filter(utilBuildings.isUnderConstruction)
            .forEach(function (building) {
            var timeLeft = utilTime.secondsLeftTill(building.proto.remainingTime);
            if (timeLeft <= 0) {
                actions.push(actionBaseInfoFinishConstruction(building.proto));
                if (selectedBuilding && selectedBuilding.proto.id === building.proto.id) {
                    actions.unshift(actionBuildingsSelectForData(selectedBuilding, buildingCenterCoords));
                }
            }
        });
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeConstruction.ts
// module id = 2431
// module chunks = 3